module.exports = __webpack_public_path__ + "static/media/edit-role-permissions.397ec3ea.png";